import { render, staticRenderFns } from "./ViewLogisticRoute.vue?vue&type=template&id=22f0dbfa&scoped=true"
import script from "./ViewLogisticRoute.vue?vue&type=script&lang=ts"
export * from "./ViewLogisticRoute.vue?vue&type=script&lang=ts"
import style0 from "./ViewLogisticRoute.vue?vue&type=style&index=0&id=22f0dbfa&prod&lang=scss&scoped=true"
import style1 from "./ViewLogisticRoute.vue?vue&type=style&index=1&id=22f0dbfa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f0dbfa",
  null
  
)

export default component.exports